import React from "react";

const Location = () => {
  return (
    <section id="about-us" className="section -mb-8 lg:mb-10 md:p-12">
      <h1 className="secondary-heading text-main mb-4 md:mb-5 lg:mb-6 md:pb-3 lg:pb-4 underline about-us-title">
        About Us
      </h1>
      <section className="lg:flex lg:flex-row-reverse">
        <p className="text-main text-lg mb-3 lg:pl-6 2xl:text-2xl">
          We are a <span className="font-semibold">high-rated</span> Private
          Hospital located in Marol, Mumbai. <br /> Here at{" "}
          <span className="font-semibold">Medicare Hospital</span>, our priority
          is bringing <span className="font-semibold">exceptional service</span>{" "}
          to our patients through our{" "}
          <span className="font-semibold">
            experienced medical professionals.{" "}
          </span>
        </p>
        <div className="relative m-auto border-2 border-blue-600 rounded-md">
          <div className="h-max relative">
            <img
              className="lg:mr-4 relative w-full h-42 opacity-70 z-10"
              src="images/front_gate.jpeg"
              alt="Medicate Hospital Front Gate"
            />
            <a
              className="absolute w-min mr-auto ml-auto left-0 right-0 text-center p-0 z-50 bottom-6"
              target="_blank"
              href="https://www.google.com/maps/place/Medicare+Hospital,+Near+Petrol+Pump,+Marol+Naka,+Andheri+Kurla+Road,+Andheri+East,+Mumbai,+Maharashtra+400059,+India/@19.1084333,72.8777682,16z/data=!4m2!3m1!1s0x3be7c8152762c2cb:0x84d6ca6723c23313"
            >
              <button class="button is-link ">View on Map</button>
            </a>
          </div>
        </div>
      </section>
      <div className="m-auto w-full lg:float-left relative py-4 xl:w-5/12">
        <div className="flex w-full h-20 px-3 py-2 border-2 rounded-tl-2xl rounded-br-2xl shadow-lg border-blue-600">
          <img src="images/nabh.png" alt="NABH certifcation" width="65" />
          <p className="inline overflow-auto ml-3 text-lg my-auto text-main">
            NABH Certified (Entry Level)
          </p>
        </div>
      </div>
      <br />
    </section>
  );
};

export default Location;
